import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import Styles from './CrossPostIcon.module.scss'
import { InstagramBrand } from 'blaze-ui/icons/24/InstagramBrand'
import LinkedInBrand from 'blaze-ui/icons/32/LinkedInBrand'
import { FacebookBrand } from 'blaze-ui/icons/35/FacebookBrand'
import TwitterBrand from 'blaze-ui/icons/20/TwitterBrand'
import { TikTokBrand, YouTubeBrand } from 'blaze-ui/icons'
import { InstagramReelsBrand } from 'blaze-ui/icons/30'

const Icon = ({ provider, isReels }: { provider: ExternalIntegrationEnum; isReels?: boolean }) => {
  switch (provider) {
    case ExternalIntegrationEnum.Instagram:
      return isReels ? <InstagramReelsBrand size={20} /> : <InstagramBrand size={20} />
    case ExternalIntegrationEnum.LinkedIn:
      return <LinkedInBrand size={20} />
    case ExternalIntegrationEnum.Facebook:
      return <FacebookBrand size={20} />
    case ExternalIntegrationEnum.X:
      return <TwitterBrand size={20} />
    case ExternalIntegrationEnum.TikTok:
      return <TikTokBrand size={20} />
    case ExternalIntegrationEnum.YouTube:
      return <YouTubeBrand size={20} />
    default:
      return null
  }
}

const CrossPostIcon = ({ providers, isReels }: { providers: ExternalIntegrationEnum[]; isReels?: boolean }) => {
  return (
    <div className={Styles.root}>
      {providers.map((provider) => (
        <div className={Styles.icon} key={provider}>
          <Icon provider={provider} isReels={isReels} />
        </div>
      ))}
    </div>
  )
}

export default CrossPostIcon
